import { render } from "./RegistrationRole.vue?vue&type=template&id=3a713e93&scoped=true"
import script from "./RegistrationRole.vue?vue&type=script&lang=js"
export * from "./RegistrationRole.vue?vue&type=script&lang=js"

import "./RegistrationRole.vue?vue&type=style&index=0&id=3a713e93&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a713e93"]])

export default __exports__